import { render } from "./EditTaxes.vue?vue&type=template&id=40c9643c&scoped=true"
import script from "./EditTaxes.vue?vue&type=script&lang=js"
export * from "./EditTaxes.vue?vue&type=script&lang=js"

import "./EditTaxes.vue?vue&type=style&index=0&id=40c9643c&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c9643c"]])

export default __exports__